// TEMPLATE TODO: update path and action type
export const apiPath = '/v2/notifications';
const actionType = 'NOTIFICATION';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
